<template>
  <div id="app">
    <div class="themeMedium">
      <div class="grid-container">
        <div class="grid-x searchForm"   style="width: 100%; position:relative"  v-if="FreedomAppConfig.useSearch === 'yes'">
          <div  style="display: block;  margin-right: 1rem;   flex-grow: 1;   width: 100%;">
            <search class="searchIcon"
                v-if="FreedomAppConfig.searchIcon === 'yes'"
                style="position: absolute; left: 10px; top: 8px;"
                :color="FreedomAppConfig.searchIconColor"
            />
            <input  class="searchInput"
                    type="search"
                    :placeholder="FreedomAppConfig.searchPlaceholder"
                    v-model="searchString"
                    :style="styles.searchInput"
            />
          </div>
        </div>
        <type-group-select :types="types" :value="selectedTagsByTypes" :dateFormated="dateRangeFormatted" :activities="activities" :selected="selectedTags" @search="search($event)"
                           @input="updateTagsByType"   @date="onDatepickerSelect"  @tag="updateSelectedTags"
        />
      </div>
    </div>

    <div class="grid-container programLegend">
      <div class="grid-x grid-margin-x programLegend-grid">
        <div class="cell auto shrink programLegend-title">
          <h5 class="h6">CLASS FORMATS:</h5>
        </div>
        <div class="cell medium-auto programLegend-content">
          <template v-for="(item, i) in getFormatOptions()"
                    >
            <span :key="`formatIcon_${i}`" class="h6 programLegend-item"><i :class="[getIcon(item.value)]"></i>{{item.value}}</span>
          </template>
        </div>

      </div>
    </div>
    <div class="grid-container" :style="gutterStyle" style="min-height: 600px">

          <div v-if="eventsFiltered.length || dirItemsFiltered.length" style="display: flex; flex-direction: column; width: 100%; ">

              <div v-if="FreedomAppConfig.dirName && dirItemsFiltered.length">
                  <div
                      v-text="FreedomAppConfig.dirString"
                      :style="{color: FreedomAppConfig.eventDateTitleColor}"
                      class="event-date-title"
                  />
                  <div class="events-container">
                      <event
                          v-for="(item, i) in dirItemsFiltered.slice(0, FreedomAppConfig.dirMaxVisible)"
                          :key="`directory_event_${i}`"
                          :activities="activities"
                          :linkTemplate="FreedomAppConfig.dirLinkTemplate"
                          :readMoreText="FreedomAppConfig.dirReadMoreText"
                          :event="{
                              id: item['id'],
                              tags: item['tags'],
                              title: item['name'],
                              directory: item['directory'],
                              description: item[FreedomAppConfig.dirDescField],
                              videoId: item[FreedomAppConfig.dirVideoField],
                          }"
                          @popupDetail="showVideoDetail"
                      />
                  </div>
                  <div v-if="dirItemsFiltered.length > FreedomAppConfig.dirMaxVisible" style="font-size: 14px; text-align: right;">
                      <div>
                          Showing {{FreedomAppConfig.dirMaxVisible}} of {{dirItemsFiltered.length}} {{FreedomAppConfig.dirString}} Items
                      </div>
                      <div
                          v-if="FreedomAppConfig.dirViewAllLinkText"
                          v-text="FreedomAppConfig.dirViewAllLinkText"
                          :title="`${FreedomAppConfig.dirViewAllLinkText} ${FreedomAppConfig.dirString}`"
                          style="cursor: pointer; font-weight: 500; text-decoration: underline;"
                          @click="goToLink(dirViewAllLink)"
                      />
                  </div>
              </div>

              <div v-for="(date, i) in dates" :key="`date_${i}`">
                  <div >
                      <div
                          v-text="moment(date.date).format(FreedomAppConfig.eventDateTitleFormat)"
                          :style="{color: FreedomAppConfig.eventDateTitleColor}"
                          class="event-date-title"
                      />
                      <div class="events-container" v-if="eventsFiltered.filter(e => e['startDate'] === date.date).length">
                          <event
                              v-for="(event, i) in eventsFiltered.filter(e => e['startDate'] === date.date).sort((a, b) => {
                                  if(a.startTime) {
                                       a.startTime.localeCompare(b.startTime)
                                  } else { return -1 }
                              })"
                              :key="`event_${i}`"
                              :event="event"
                              :activities="activities"
                              :linkTemplate="FreedomAppConfig.eventLinkTemplate"
                          />
                      </div>
                    <div v-else><p>No Events to Display</p></div>
                  </div>
              </div>
          </div>
          <div v-else id="no-events-notice">
              <calendar-remove style="height: 30px;"/>
              <span style="margin-left: 10px;" v-text="FreedomAppConfig.noEventsText"/>
          </div>
          <div id="fetching-events-notice"  class="text-center" v-if="fetchingEvents">
              <i class="fa fa-spin fa-spinner" />
              <span style="margin-left: 10px;" >Updating Results</span>
          </div>


      </div>
      <div class="grid-container" :style="gutterStyle" v-if="!fetchingEvents">
          <p class="text-center">
              <button @click="loadNextWeek()" class="button">Load Another Week</button>
          </p>

      </div>


    <div id="onDemand-popup" :class="showModal?'active':false" >
      <button @click="toggleModal" class="onDemand-popup-close close-button" aria-label="Close dialog" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
      <youtube  class="onDemand-popup-content" v-if="showModal && videoId" :video-id="videoId" player-width="100%" player-height="100%"></youtube>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import FreedomAPI from "./FreedomAPI";
import FreedomAppConfig from "./FreedomAppConfig";
import Event from "./components/event";
import Search from "./assets/search";
import TypeGroupSelect from "./components/type-group-select";
import CalendarRemove from "./assets/calendar-remove";
import Lodash from "lodash";

export default {
    name: 'App',
    components: {CalendarRemove,TypeGroupSelect, Event, Search},
    data: function() {
        return {
            FreedomAppConfig,
            moment,
            types: FreedomAppConfig.types.split(',').map(t => this.getPrefixObject(t.trim())),
            activities: FreedomAppConfig.activities.split(',').map(a => this.getPrefixObject(a.trim())),
            selectedType: {}, // {prefix: '', value: ''}
            selectedTags: [],
            selectedTagsByTypes: {},

            dirItems: [], // 'on demand' directory items
            dirItemsFiltered: [],

            searchString: '', // Search string

            visibleActivities: [],
            videoId: '',

            showModal: false,

            events: [], // Intended to be ALL events within the date range shown
            eventsFiltered: [], // THE ACTUAL FILTERED EVENTS TO DISPLAY
            range: {start: '', end: ''},
            dates: [],
            fetchingEvents: true,

            selectedDate: '',//moment().format('YYYY-MM-DD'),

            styles: {
                banner: {
                    'display': 'flex', 'background-color': FreedomAppConfig.bannerColor
                },
                dateBanner: {
                    'display': 'flex', 'background-color': FreedomAppConfig.dateBannerColor,
                    'border-bottom': '1px solid rgba(168, 172, 177, 0.4)'
                },
                searchInput:{'border': '2px solid', 'border-color': FreedomAppConfig.searchIconColor, 'padding-left': '50px', 'max-width': '800px'}
            },
        }
    },
    computed: {
        gutterStyle: function() {
            return {
                'min-width': FreedomAppConfig.gutterMinWidth,
                // 'max-width': FreedomAppConfig.gutterMaxWidth,
                'margin': '0 auto',
                'display': 'block',
                'width': '100%'
            };
        },
        dirViewAllLink: function() {
            /** @type {TemplateExecutor} */
            const templateExec = Lodash.template(FreedomAppConfig.dirLinkViewAllTemplate);
            return templateExec({directory: FreedomAppConfig.dirName});
        },
        dateRangeFormatted: function(){

          return moment(this.range.start).format('MMM. Do') + '-' + moment(this.range.end).format('MMM. Do')
        },

    },
    watch: {
        // selectedTags: function() {
        //     this.filterEvents();
        // },
        // selectedDate: function() {
        //     this.filterEvents();
        // },
      searchString: Lodash.debounce(function(newValue) {
        this.search(newValue)
      }, 300),
      selectedTagsByTypes: function (){
        this.filterEvents();
      }
    },
    beforeMount: async function (){
      let search = location.search.substring(1);

      let params  = {};
      if (search.length) {
        params = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
          return key === "" ? value : decodeURIComponent(value)
        })
      }
      let tmp = {};
      this.types.forEach(t => {
        let urlparam = t.prefix + '_filter';
        if (params[urlparam] !== undefined) {
          tmp[t.prefix] = params[urlparam].toLowerCase().split(',');//to support multiple of type
        } else {
          tmp[t.prefix] = []
        }
      });

      if(FreedomAppConfig.useSearch === 'yes') {
        let urlparam = 'search_filter';
        if (params[urlparam] !== undefined) {
          this.searchString = params[urlparam].toLowerCase().replace(/\+/g, ' ');
        }
      }

      this.updateTagsByType(tmp);

    },
    mounted: async function() {
        await this.getDirItems(); // Grab all our directory items once
        await this.setDateRange(new Date());

    },
    methods: {
        toggleModal: function(){
          this.showModal = !this.showModal;
        },
        showVideoDetail: function(videoId){
          this.videoId = videoId;
          this.toggleModal();

        },
        goToLink: function(link) { window.location = link },
        updateTagsByType: function(newSelected){
          this.selectedTagsByTypes = Object.assign({}, this.selectedTagsByTypes, newSelected)

          let tmp = Object.keys(newSelected).reduce(function(p,c){
            return p.concat(newSelected[c]);  },[]);
          this.updateSelectedTags(tmp);
        },
        updateSelectedTags: function(tags) {
          this.selectedTags = tags;
        },
        clearSelectedTags: function() {
          this.selectedTags = [];
        },
        getIcon: function(value) {
          value = value.trim().replaceAll(' ', '_');
          return FreedomAppConfig[`icon_${value}`];
        },
        getFormatOptions: function(){
          return this.activities.filter(a => a['prefix'] === this.FreedomAppConfig.eventFormatPrefix);
        },
        getPrefixObject: function(string) {

          const pieces = string.split('-');
          if (pieces.length >= 2){
            pieces.push(pieces.splice(1).join('-'));
          }
            return {prefix: pieces[0], value: pieces[1]};
        },

        search: async function(str) {
            this.searchString = str;
            this.filterEvents();
        },

        // Set filteredEvents based on ALL parameters selected
      filterEvents: function() {
        this.eventsFiltered = this.events.filter(() => true);

        // Filter out based on tag
        let typeTags = [];
        if (this.selectedTags.length) {
          for( let type in this.selectedTagsByTypes){
            typeTags = this.selectedTagsByTypes[type];
            // console.log('tags events',typeTags, typeTags.length, test);
            if(typeTags.length) {
              this.eventsFiltered = this.eventsFiltered.filter(e => {
                const tags = e.tags.map(t => t.name.toLowerCase());
                return tags.some(tag => typeTags.indexOf(tag) !== -1);
              });
            }
          }
        }

        // Filter out for exact selected date
        // if (this.selectedDate) {
        //   console.log('selected DAte', this.selectedDate);
        //   this.eventsFiltered = this.eventsFiltered.filter(e => this.selectedDate === e['startDate']);
        // }

        // Filter by search string
        if (FreedomAppConfig.useSearch === 'yes' && this.searchString && typeof(this.searchString) === 'string') {
          const searchLower = this.searchString.toLowerCase();
          const matchedTags = []; // Tags that have been matched positively already
          this.eventsFiltered = this.eventsFiltered.filter(e => {
            // Do straight string compares first
            if (e.title && e.title.toLowerCase().includes(searchLower)) return true;
            if (e.description && e.description.toLowerCase().includes(searchLower)) return true;
            if (e['startDate'] && e['startDate'].includes(searchLower)) return true;
            if (e['startTime'] && e['startTime'].includes(searchLower)) return true;

            // Note - Iterate through tags last since it adds significantly more complexity
            if (e.tags.map(t => t.name.toLowerCase()).some(tag => {
              if (matchedTags.indexOf(tag) !== -1) return true;
              if (tag.includes(searchLower)) {
                matchedTags.push(tag);
                return true;
              }
            })) return true;

            // No match to search string found
            return false;
          });
        } // End of search string filtering

        //optional get dates to show from the current filtered data set
        // not using now because we want to show every day and whether they have events or not
        // var o = {}; this.eventsFiltered.map(function(v){ o[v['startDate']] = 1; });
        // this.datesFromEvents(Object.keys(o));

        //// FILTER DIR ITEMS (must match a tag to show) ////
        this.dirItemsFiltered = [];
        if (this.selectedTags.length) {
          this.dirItemsFiltered = [...this.dirItems];
          for( let type in this.selectedTagsByTypes){
             typeTags = this.selectedTagsByTypes[type];
            if(typeTags.length) {
              this.dirItemsFiltered = this.dirItemsFiltered.filter(item => {
                const tags = item.tags.map(t => t.name.toLowerCase());

                return tags.some(tag => typeTags.indexOf(tag) !== -1);
              });
            }

          }

          // Filter by text search also if search active
          if (FreedomAppConfig.useSearch === 'yes' && this.searchString && typeof(this.searchString) === 'string') {
            const searchLower = this.searchString.toLowerCase();
            const matchedTags = []; // Tags that have been matched positively already
            this.dirItemsFiltered = this.dirItemsFiltered.filter(item => {
              // Do straight string compares first
              if (item['name'] && item['name'].toLowerCase().includes(searchLower)) return true;
              if (item[FreedomAppConfig.dirDescField] && item[FreedomAppConfig.dirDescField].toLowerCase().includes(searchLower)) return true;
              // Note - Iterate through tags last since it adds significantly more complexity
              if (item.tags && item.tags.map(t => t.name.toLowerCase()).some(tag => {
                if (matchedTags.indexOf(tag) !== -1) return true;
                if (tag.includes(searchLower)) {
                  matchedTags.push(tag);
                  return true;
                }
              })) return true;
              // No match to search string found
              return false;
            });
          }
        }
        /////////////////////////////////////////////////////
      },

      datesFromEvents: function(aDates){
        this.dates = [];

        aDates.forEach(date =>{
          let day = moment(date);
          this.dates.push({
            text: day.format(FreedomAppConfig.dateSelectFormat),
            date: day.format('YYYY-MM-DD'),
          });

        })
      },
        changeDates: function(direction) {
            let unsetDate = false;
            if (!this.selectedDate) {
                unsetDate = true;
                this.selectedDate = this.dates[1].date;
            }
            this.selectedDate = (direction === 'forward')
                ? moment(this.selectedDate).add(2, 'week').format('YYYY-MM-DD')
                : moment(this.selectedDate).subtract(2, 'week').format('YYYY-MM-DD');
            this.setDateRange(this.selectedDate);
            if (unsetDate) {
                this.selectedDate = '';
            }
        },
       onDatepickerSelect: function(date){
          let oldDate = this.selectedDate;
         this.selectedDate = date ? moment(date).format('YYYY-MM-DD') : '';
         if( this.selectedDate && oldDate !== this.selectedDate  ) {
           this.setDateRange(this.selectedDate);
         } else {
           this.filterEvents();
         }
       },

        getEvents: async function(start, end) {
            this.fetchingEvents = true;
            this.eventsFiltered = [];
            const params = {
                active: `"yes"`,
                visible: `"yes"`,
                between: `{from: "${start}", to: "${end}"}`,
                orderBy: `{field: "start_date", order: ASC}`,
            };
            const paginationSize = 150;
            let page = 1;
            const fields = ['id', 'title', 'startDate', 'startTime', 'endDate', 'endTime', 'description', `tags {name}`];
            const query = FreedomAPI.buildQuery('webEvent', fields, params, paginationSize);
            let response = await FreedomAPI.query(query, 'webEvent');
            let events = response.data;
            if ( response.paginatorInfo ){
                let  totalPages =  Math.ceil(response.paginatorInfo.total / paginationSize );
                while ( page < totalPages){
                    page++;
                    const query = FreedomAPI.buildQuery('webEvent', fields, params, paginationSize, page);
                    response = await FreedomAPI.query(query, 'webEvent');
                    events = events.concat(response.data);
                    if(response.paginatorInfo.count === 0){
                        break;
                    }
                }
            }

            this.events = events;
            this.fetchingEvents = false ;

        },
        appendMoreEvents: async function(start, end) {
            this.fetchingEvents = true;
            // this.eventsFiltered = [];
            const params = {
                active: `"yes"`,
                visible: `"yes"`,
                between: `{from: "${start}", to: "${end}"}`,
                orderBy: `{field: "start_date", order: ASC}`,
            };
            const paginationSize = 150;
            let page = 1;
            const fields = ['id', 'title', 'startDate', 'startTime', 'endDate', 'endTime', 'description', `tags {name}`];
            const query = FreedomAPI.buildQuery('webEvent', fields, params, paginationSize);
            let response = await FreedomAPI.query(query, 'webEvent');
            let events = response.data;
            if ( response.paginatorInfo ){
                let  totalPages =  Math.ceil(response.paginatorInfo.total / paginationSize );
                while ( page < totalPages){
                    page++;
                    const query = FreedomAPI.buildQuery('webEvent', fields, params, paginationSize, page);
                    response = await FreedomAPI.query(query, 'webEvent');
                    events = events.concat(response.data);
                    if(response.paginatorInfo.count === 0){
                        break;
                    }
                }
            }

            this.events = this.events.concat(events);
            this.fetchingEvents = false ;
        },

        getDirItems: async function() {
            if (!FreedomAppConfig.dirName || FreedomAppConfig.dirName === '') return;
            const params = {directory: `"${FreedomAppConfig.dirName}"`, visible: `"yes"`};
            const miscFields = [...Array(10).keys()].map(i => `misc${i}`);
            const fields = ['id', 'directory', 'name', `tags {name}`, ...miscFields];
            const query = FreedomAPI.buildQuery('webDirectoryItem', fields, params, 100);
            const data = await FreedomAPI.query(query, 'webDirectoryItem');
            this.dirItems = data.data;
        },

        /**
         * Creates date range based on date.
         * Will show the monday -> Sunday given date falls into
         * @param date
         */
        setDateRange: async function(date) {
            let iDaysOut = FreedomAppConfig.daysToLoad;
            this.range.start = moment(date).format('YYYY-MM-DD') + ' 00:00:00';
            this.range.end = moment(date).add(iDaysOut, 'day').format('YYYY-MM-DD') + ' 23:59:59';
            let day = moment(date);
            this.dates = [];
            for (let i = 0; i < iDaysOut; i++) {
              let clone = day.clone();
              clone.add(i, 'd');
              this.dates.push({
                text: clone.format(FreedomAppConfig.dateSelectFormat),
                date: clone.format('YYYY-MM-DD'),
              });
            }
            await this.getEvents(this.range.start, this.range.end);
            this.filterEvents();
        },
        loadNextWeek: async function(){
            let iDaysOut = 7;
            let startDayMoment = moment(this.range.end);
            const newStart = moment(this.range.end).add(1, 'day').format('YYYY-MM-DD') + ' 00:00:00';
            const newEnd = moment(newStart).add(iDaysOut, 'day').format('YYYY-MM-DD') + ' 23:59:59';
            this.range.end = newEnd;

            await this.appendMoreEvents(newStart, newEnd);
            for (let i = 0; i < iDaysOut; i++) {
                let clone = startDayMoment.clone();
                clone.add(i, 'd');
                this.dates.push({
                    text: clone.format(FreedomAppConfig.dateSelectFormat),
                    date: clone.format('YYYY-MM-DD'),
                });
            }
            this.filterEvents();
        }
    }
}
</script>

<style>
.datepicker-input[readonly] {
  background: #f4f4f4;
  cursor:default;
}
.datepicker-input::placeholder{color:#000}


.vdp-datepicker__clear-button {
  display: inline-block;
  position: absolute;
  right: 10px;
  top: 0px;
}
.vdp-datepicker__clear-button i {
  color: red;
  font-size: 22px;
  font-style: normal;
  position: relative;
}

#eventSearchHeroComponent { height: 250px }
.arrowLink{font-weight:700;cursor:pointer;display:flex;flex-flow:row nowrap;justify-content:flex-start;align-items:center;text-transform:uppercase}
.arrowLink:after{content:'';transition:all .3s cubic-bezier(.36,.53,.33,1.01);color:transparent;font-size:.5em;border:none;border-bottom:2px solid currentColor;border-left:2px solid currentColor;height:10px;width:10px;transform:translateX(0) translateY(-8%) rotate(-135deg)}
.arrowLink:hover,a:hover .arrowLink{color:inherit}
.arrowLink:hover:after,a:hover .arrowLink:after{color:#1c1733;transform:translateX(1rem) translateY(-8%) rotate(-135deg)}
.vueEventSearch { top: -75px;}
.programLegend-item {    text-transform: capitalize;}
.programLegend-item i {  margin-right: 8px;}
.programLegend-title h5 {    font-weight: bold;    margin: 0;}
.programLegend-grid {  align-items: center;}

.searchDropdowns-cell{  flex-flow: row wrap;}
.searchType, .searchType .button { width: 100%}
@media screen and ( min-width: 640px){
  .searchType {width: calc(50% - 1rem);}

}
@media screen and ( min-width: 888px){
  #eventSearchHeroComponent { height: 450px}
  .vueEventSearch { top: -190px; z-index: 4; }
  .searchType, .searchType .button { width: auto;}
}

</style>
<style scoped>
.type-select { text-transform: capitalize;
min-width: 175px;
}

.events-container {
    padding: 1rem;
    margin: 5px 0 20px 0;
  box-shadow: 0px 3px 15px rgba(0,0,0,.3);
}

.event-date-title {
    margin: 10px 0 0 0;
    font-size: 22px;
    font-weight: 700;
    padding: 0 0 5px 0;
}

#no-events-notice {
    display: flex;
    justify-content: center;
    padding: 60px 0;
    width: 100%;
    align-items: center;
}
.programLegend {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.programLegend-item {
  margin-right: 3rem;
}


#onDemand-popup {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  width: 100%;
  /*height: 100%;*/
  z-index: 999;
  transition: all 0.3s cubic-bezier(0.36, 0.53, 0.33, 1.01);
  height: 0;
  opacity: 0;
}
#onDemand-popup .onDemand-popup-close {
  font-size: 50px;
  color: #fefefe;
  width: 50px;
  height: 50px; }

#onDemand-popup.active {
  height: 100%;
  opacity: 1; }

#onDemand-popup .onDemand-popup-content {
  display: block;
  width: 95%;
  height: 240px;
}
@media screen and (min-width: 40em) and (min-height: 475px) {
  #onDemand-popup.active .onDemand-popup-content {
    width: 720px;
    height: 480px; }
}


</style>